<template>
  <div class="MyExperiences p-6 w-full h-full relative overflow-hidden">
    <div id="myExperiences" class="flex justify-center w-full h-full">
      <div class="w-full flex flex-wrap mt-24 z-10 justify-center">
        <div class=" w-full lg:w-1/3 mt-5 md:mt-0 pb-10 " v-for="(item,index) in myExperiences" :key="index">
            <div class="card transition-1 bg-background-primaryDark flex flex-col p-12 items-center text-center 20 ml-5 mr-5 shadow-xl wow fadeInUp" data-wow-delay=".3s">
                <span>
                    <svg viewBox="0 0 24 24" fill="#bf80ff" xmlns="http://www.w3.org/2000/svg" class="fill-current svg-gradient w-16 transition-1" v-html="item.svg" />
                </span>
                <span class="font-bold text-mytext-primary text-2xl mt-2 tracking-wide" v-text="item.name" />
                <span class="text-mytext-primary pt-10" v-text="item.details" />
                <span class="text-xl text-gradient pt-10" v-text="item.title1" />
                <span class="text-mytext-primary pt-5" v-text="item.details1" />
                <span class="text-xl text-gradient pt-10" v-text="item.title2" />
                <span class="text-mytext-primary pt-5" v-text="item.details2" />
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyExperiences',
  data() {
    return {
        myExperiences:[
            {
                id:1,
                name:this.$i18n.t('myExperiences.1.name'),
                details:this.$i18n.t('myExperiences.1.details'),
                title1:this.$i18n.t('myExperiences.1.title1'),
                details1:this.$i18n.t('myExperiences.1.details1'),
                title2:this.$i18n.t('myExperiences.1.title2'),
                details2:this.$i18n.t('myExperiences.1.details2'),
                svg:"<path d='M5.0333 14.8284L6.44751 16.2426L10.6902 12L6.44751 7.75733L5.0333 9.17155L7.86172 12L5.0333 14.8284Z' fill='currentColor'></path><path d='M15 14H11V16H15V14Z' fill='currentColor'></path><path fill-rule='evenodd' clip-rule='evenodd' d='M2 2C0.895431 2 0 2.89543 0 4V20C0 21.1046 0.89543 22 2 22H22C23.1046 22 24 21.1046 24 20V4C24 2.89543 23.1046 2 22 2H2ZM22 4H2L2 20H22V4Z' fill='currentColor'></path>"

            },
            {
                id:2,
                name:this.$i18n.t('myExperiences.2.name'),
                details:this.$i18n.t('myExperiences.2.details'),
                title1:this.$i18n.t('myExperiences.2.title1'),
                details1:this.$i18n.t('myExperiences.2.details1'),
                title2:this.$i18n.t('myExperiences.2.title2'),
                details2:this.$i18n.t('myExperiences.2.details2'),
                svg:"<path fill-rule='evenodd' clip-rule='evenodd' d='M11 17H4C2.34315 17 1 15.6569 1 14V6C1 4.34315 2.34315 3 4 3H20C21.6569 3 23 4.34315 23 6V14C23 15.6569 21.6569 17 20 17H13V19H16C16.5523 19 17 19.4477 17 20C17 20.5523 16.5523 21 16 21H8C7.44772 21 7 20.5523 7 20C7 19.4477 7.44772 19 8 19H11V17ZM4 5H20C20.5523 5 21 5.44772 21 6V14C21 14.5523 20.5523 15 20 15H4C3.44772 15 3 14.5523 3 14V6C3 5.44772 3.44772 5 4 5Z' fill='currentColor'></path>"
            },
            {
                id:3,
                name:this.$i18n.t('myExperiences.3.name'),
                details:this.$i18n.t('myExperiences.3.details'),
                title1:this.$i18n.t('myExperiences.3.title1'),
                details1:this.$i18n.t('myExperiences.3.details1'),
                title2:this.$i18n.t('myExperiences.3.title2'),
                details2:this.$i18n.t('myExperiences.3.details2'),
                svg:"<path d='M19.1,11.1c-0.1-0.2-0.3-0.3-0.4-0.3c-0.9,0.2-1.7,0-2-0.5c-0.3-0.5-0.1-1.3,0.6-2c0.1-0.1,0.1-0.4,0-0.5 c-0.9-0.9-2-1.6-3.3-1.9c-0.2-0.1-0.4,0.1-0.5,0.3C13.2,7,12.6,7.6,12,7.6S10.8,7,10.5,6.1c-0.1-0.2-0.3-0.3-0.5-0.3 c-1.3,0.3-2.4,1-3.3,1.9c-0.1,0.1-0.1,0.4,0,0.5c0.6,0.7,0.9,1.5,0.6,2c-0.3,0.5-1.1,0.7-2,0.5c-0.2,0-0.4,0.1-0.4,0.3 c-0.2,0.6-0.3,1.3-0.3,1.9s0.1,1.3,0.3,1.9c0.1,0.2,0.3,0.3,0.4,0.3c0.9-0.2,1.7,0,2,0.5c0.3,0.5,0.1,1.3-0.6,2 c-0.1,0.1-0.1,0.4,0,0.5c0.9,0.9,2,1.6,3.3,1.9c0,0,0.1,0,0.1,0c0.2,0,0.3-0.1,0.4-0.3c0.3-0.9,0.8-1.5,1.5-1.5s1.2,0.6,1.5,1.5 c0.1,0.2,0.3,0.3,0.5,0.3c1.3-0.3,2.4-1,3.3-1.9c0.1-0.1,0.1-0.4,0-0.5c-0.6-0.7-0.9-1.5-0.6-2c0.3-0.5,1.1-0.7,2-0.5 c0.2,0,0.4-0.1,0.4-0.3c0.2-0.6,0.3-1.3,0.3-1.9S19.3,11.7,19.1,11.1z M12.9,13.4c-0.1,0.1-0.1,0.2-0.2,0.3C12.5,13.9,12.3,14,12,14 c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.3,0.1-0.4 c0.1-0.1,0.1-0.2,0.2-0.3c0.4-0.4,1-0.4,1.4,0c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0.1,0.3,0.1,0.4C13,13.1,13,13.3,12.9,13.4z'/> <path d='M28.9,17.6L26,11.8C25.9,6.4,21.4,2,16,2c-2.4,0-4.6,0.8-6.4,2.3C10.4,4.1,11.2,4,12,4c5,0,9,4,9,9c0,5-4,9-9,9 c-1.1,0-2.1-0.2-3-0.5V27c0,0.5,0.3,0.9,0.8,1l10,2c0.1,0,0.1,0,0.2,0c0.2,0,0.5-0.1,0.6-0.2c0.2-0.2,0.4-0.5,0.4-0.8v-4h2 c1.7,0,3-1.3,3-3v-3h2c0.3,0,0.7-0.2,0.9-0.5S29,17.9,28.9,17.6z'/>"
            },
            {
                id:4,
                name:this.$i18n.t('myExperiences.4.name'),
                details:this.$i18n.t('myExperiences.4.details'),
                title1:this.$i18n.t('myExperiences.4.title1'),
                details1:this.$i18n.t('myExperiences.4.details1'),
                title2:this.$i18n.t('myExperiences.4.title2'),
                details2:this.$i18n.t('myExperiences.4.details2'),
                svg:"<path fill-rule='evenodd' clip-rule='evenodd' d='M11 17H4C2.34315 17 1 15.6569 1 14V6C1 4.34315 2.34315 3 4 3H20C21.6569 3 23 4.34315 23 6V14C23 15.6569 21.6569 17 20 17H13V19H16C16.5523 19 17 19.4477 17 20C17 20.5523 16.5523 21 16 21H8C7.44772 21 7 20.5523 7 20C7 19.4477 7.44772 19 8 19H11V17ZM4 5H20C20.5523 5 21 5.44772 21 6V14C21 14.5523 20.5523 15 20 15H4C3.44772 15 3 14.5523 3 14V6C3 5.44772 3.44772 5 4 5Z' fill='currentColor'></path>"
            },
            {
                id:5,
                name:this.$i18n.t('myExperiences.5.name'),
                details:this.$i18n.t('myExperiences.5.details'),
                title1:this.$i18n.t('myExperiences.5.title1'),
                details1:this.$i18n.t('myExperiences.5.details1'),
                title2:this.$i18n.t('myExperiences.5.title2'),
                details2:this.$i18n.t('myExperiences.5.details2'),
                svg:"<path fill-rule='evenodd'clip-rule='evenodd' d='M12.0122 5.57169L10.9252 4.48469C8.77734 2.33681 5.29493 2.33681 3.14705 4.48469C0.999162 6.63258 0.999162 10.115 3.14705 12.2629L11.9859 21.1017L11.9877 21.0999L12.014 21.1262L20.8528 12.2874C23.0007 10.1395 23.0007 6.65711 20.8528 4.50923C18.705 2.36134 15.2226 2.36134 13.0747 4.50923L12.0122 5.57169ZM11.9877 18.2715L16.9239 13.3352L18.3747 11.9342L18.3762 11.9356L19.4386 10.8732C20.8055 9.50635 20.8055 7.29028 19.4386 5.92344C18.0718 4.55661 15.8557 4.55661 14.4889 5.92344L12.0133 8.39904L12.006 8.3918L12.005 8.39287L9.51101 5.89891C8.14417 4.53207 5.92809 4.53207 4.56126 5.89891C3.19442 7.26574 3.19442 9.48182 4.56126 10.8487L7.10068 13.3881L7.10248 13.3863L11.9877 18.2715Z' fill='currentColor'></path>"
            },
        ]
    }
  },
  computed: {
    langLocaleNow(){
      return this.$i18n.locale
    }
  },
  watch: {
    langLocaleNow(){
      Object.assign(this.$data,this.$options.data.call(this))
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.MyExperiences:before {
    clip-path: polygon(0 0,100% 0,100% 0, 100% 10%,0 100%);
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background:linear-gradient(to top,#008fb3,#99ebff);
    z-index: 0;
}
.card:hover svg{
        transform: scale(1.3);
}
</style>